export enum CGRActionTypes {
  POST_CGR_REQUEST = "@@cgr/POST_CGR_REQUEST",
  POST_CGR_SUCCESS = "@@cgr/POST_CGR_SUCCESS",
  POST_CGR_ERROR = "@@cgr/POST_CGR_ERROR",
}

export interface CGRState {
  readonly loading: boolean;
}
